<template>
  <div class="payment-method-group">
    <div class="title" :class="type">
      <h2 v-if="type === 'recommended'">
        {{ $t("subscription.recommended") }}
      </h2>
      <h2 v-else-if="type === 'try-again'">
        {{ $t("subscription.try_again") }}
      </h2>
    </div>
    <div class="payment-method-options">
      <template v-for="(paymentMethod, index) in paymentMethods">
        <!--div
          v-if="index % 2 === 1"
          class="ver-bar"
          :key="paymentMethod.id"
        ></div>-->
        <div>
          <PaymentMethodCardOption
            :payment-method="paymentMethod"
            :selected-payment-method="selectedPaymentMethod"
            @click="setPaymentMethod"
          />
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import PaymentMethodCardOption from "./PaymentMethodCardOption";

export default {
  name: "PaymentMethodGroup",
  components: { PaymentMethodCardOption },
  props: {
    paymentMethods: {},
    selectedPaymentMethod: {},
    type: {},
  },
  methods: {
    setPaymentMethod(paymentMethod) {
      this.$emit("click", paymentMethod);
    },
  },
};
</script>
<style scoped lang="scss">
.payment-method-group {
  margin-top: 30px;

  .title {
    text-align: center;
    font-family: arial, helvetica;
    text-transform: uppercase;

    &.recommended {
    }
    &.try-again {
      font-size: 0.6em;
    }
    &.others {
    }
  }

  .payment-method-options {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  .ver-bar {
    width: 2px;
    height: 120px;
    background-color: var(--pallete_main_color);
    margin: auto 20px;
  }
}
</style>
